// extracted by mini-css-extract-plugin
export default {"modal_wrong":"ModalWrong_modal_wrong__VxJQo"};